import React, {useState, useEffect, useRef} from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate } from 'react-router';
import SuccessModal from '../../shared/SuccessModal';
import CitySearchDropdown from "../../Dropdowns/CitySearchDropdown";

const validationSchema = Yup.object().shape({
  company_name: Yup.string().required('Company name is required'),
  email: Yup.string().email('Invalid email format').required('Email is required'),
  contact_number: Yup.string().required('Contact number is required'),
  //comp_registration_number: Yup.string().required('Registration number is required'),
  company_website: Yup.string().url('Invalid URL format').required('website is required'),
  //team_size: Yup.string().required('Team size is required'),
  //established_in: Yup.string().required('Establishment year is required'),
  primary_industry: Yup.string().required('Primary industry is required'),
  //about_company: Yup.string().required('Company description is required'),
  //city: Yup.string().required('City is required'),
  //address: Yup.string().required('Address is required')
});

const CreateCompany = ({ companyId, refreshCompanyData }) => {
  const navigate = useNavigate();
  const [industries, setIndustries] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    success: false,
    message: "",
  });
  const dropdownRef = useRef(null);

  const filteredIndustries = industries.filter((industry) =>
    industry.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  useEffect(() => {
    const fetchIndustries = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}industries/get-all-industries`);
        setIndustries(response.data.industries);
      } catch (error) {
        console.error('Failed to fetch industries:', error);
      }
    };

    fetchIndustries();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const initialValues = {
    company_name: '',
    email: '',
    contact_number: '',
    comp_registration_number: '',
    company_website: '',
    team_size: '',
    established_in: '',
    primary_industry: '',
    about_company: '',
    city: '',
    address: '',
    facebook: '',
    twitter: '',
    linkedin: '',
    pinterest: '',
    whatsapp: '',
    instagram: '',
    working_hours: '',
    working_days: '',
    tagline: '',
    company_id: companyId,
    logo: null
  };

  return (
    <div className="col-lg-9">
      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">Create Company Profile</h4>
          <div className="profile-resume">
            <div className="profile-form">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={async (values, { setSubmitting }) => {
                  const formData = new FormData();
                  Object.keys(values).forEach(key => {
                    if (key === 'logo' && values[key]) {
                      formData.append(key, values[key]);
                    } else {
                      formData.append(key, values[key]);
                    }
                  });
                  try {
                    await axios.post(
                      `${process.env.REACT_APP_API_URL}companyDetails/createcompany`,
                      formData,
                      {
                        headers: {
                          'Content-Type': 'multipart/form-data'
                        }
                      }
                    );
                    setModalConfig({
                      success: true,
                      message: 'Company profile created successfully!',
                    })

                    setShowModal(true);

                  } catch (error) {
                    console.log("ERROR", error)
                    setModalConfig({
                      success: false,
                      message: 'Failed to update company details.'
                    })

                    setShowModal(true);
                  } finally {
                    setSubmitting(false);
                  }
                }}

              >
                {({ isSubmitting, setFieldValue }) => (
                  <Form>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Company Name:</label><span className="text-danger fw-bold">*</span>
                          <Field
                            type="text"
                            name="company_name"
                            className="form-control"
                            placeholder="Enter Company Name"
                          />
                          <ErrorMessage name="company_name" component="div" className="text-danger" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Email:</label><span className="text-danger fw-bold">*</span>
                          <Field
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Enter Email"
                          />
                          <ErrorMessage name="email" component="div" className="text-danger" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Contact Number:</label><span className="text-danger fw-bold">*</span>
                          <Field
                            type="text"
                            name="contact_number"
                            className="form-control"
                            placeholder="Enter Contact Number"
                          />
                          <ErrorMessage name="contact_number" component="div" className="text-danger" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Registration Number:</label>
                          <Field
                            type="text"
                            name="comp_registration_number"
                            className="form-control"
                            placeholder="Enter Registration Number"
                          />
                          <ErrorMessage name="comp_registration_number" component="div" className="text-danger" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Website:</label><span className="text-danger fw-bold">*</span>
                          <Field
                            type="text"
                            name="company_website"
                            className="form-control"
                            placeholder="Enter Website URL"
                          />
                          <ErrorMessage name="company_website" component="div" className="text-danger" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Team Size:</label>
                          <Field
                            type="text"
                            name="team_size"
                            className="form-control"
                            placeholder="Enter Team Size"
                          />
                          <ErrorMessage name="team_size" component="div" className="text-danger" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Established Year:</label>
                          <Field
                            type="text"
                            name="established_in"
                            className="form-control"
                            placeholder="Enter Established Year"
                          />
                          <ErrorMessage name="established_in" component="div" className="text-danger" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Primary Industry:</label><span className="text-danger fw-bold">*</span>
                         <Field name="primary_industry">
                          {({ field, form }) => (
                            <div className="dropdown" ref={dropdownRef}>
                             <input
                               type="text"
                               placeholder="Search Industry"
                               value={searchTerm}
                               onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setIsDropdownOpen(true);
                               }}
                               onFocus={() => setIsDropdownOpen(true)}
                               className="form-control"
                             />
                             {isDropdownOpen && (
                               <div className="dropdown-menu show w-100" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                {filteredIndustries.length > 0 ? (
                                  filteredIndustries.map((industry) => (
                                    <div
                                      key={industry.id}
                                      className="dropdown-item cursor-pointer"
                                      onClick={() => {
                                       form.setFieldValue(field.name, industry.name);
                                       setSearchTerm(industry.name);
                                       setIsDropdownOpen(false);
                                      }}
                                    >
                                     {industry.name}
                                    </div>
                                  ))
                                ) : (
                                  <div className="dropdown-item no-results">No results found</div>
                                )}
                               </div>
                             )}
                            </div>
                          )}
                         </Field>
                          <ErrorMessage name="primary_industry" component="div" className="text-danger" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Working Days:</label>
                          <Field
                            type="text"
                            name="working_days"
                            className="form-control"
                            placeholder="Enter Working Days"
                          />
                          <ErrorMessage name="working_days" component="div" className="text-danger" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Working Hours:</label>
                          <Field
                            type="text"
                            name="working_hours"
                            className="form-control"
                            placeholder="Enter Working Hours"
                          >
                          </Field>
                          <ErrorMessage name="working_hours" component="div" className="text-danger" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-full">
                        <div className="form-group">
                          <label>About Company:</label>
                          <Field
                            as="textarea"
                            name="about_company"
                            className="form-control"
                            style={{ overflow: "hidden" }}
                            placeholder="Enter a detailed company description..."
                            onInput={(e) => {
                              e.target.style.height = "auto";
                              e.target.style.height = `${e.target.scrollHeight}px`;
                            }}
                          />
                          <ErrorMessage name="about_company" component="div" className="text-danger" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-full">
                        <div className="form-group">
                          <label>Full Address:</label>
                          <Field
                            as="textarea"
                            name="address"
                            className="form-control"
                            placeholder="Enter full address of company."
                            style={{ overflow: "hidden" }}
                            onInput={(e) => {
                              e.target.style.height = "auto";
                              e.target.style.height = `${e.target.scrollHeight}px`;
                            }}
                          />
                          <ErrorMessage name="address" component="div" className="text-danger" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <Field
                            type="text"
                            name="city"
                            className="form-control"
                            placeholder="Enter City"
                          >
                            {({field, form}) => (
                              <CitySearchDropdown initialValue={""} name={field.name} label={field.name} />
                            )}
                          </Field>
                          <ErrorMessage name="city" component="div" className="text-danger" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Facebook:</label>
                          <Field
                            type="text"
                            name="facebook"
                            className="form-control"
                            placeholder="Enter Facebook URL"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Twitter:</label>
                          <Field
                            type="text"
                            name="twitter"
                            className="form-control"
                            placeholder="Enter Twitter URL"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>LinkedIn:</label>
                          <Field
                            type="text"
                            name="linkedin"
                            className="form-control"
                            placeholder="Enter LinkedIn URL"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Instagram:</label>
                          <Field
                            type="text"
                            name="instagram"
                            className="form-control"
                            placeholder="Enter Instagram URL"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>WhatsApp:</label>
                          <Field
                            type="text"
                            name="whatsapp"
                            className="form-control"
                            placeholder="Enter WhatsApp Number/URL"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Pinterest:</label>
                          <Field
                            type="text"
                            name="pinterest"
                            className="form-control"
                            placeholder="Enter Pinterest URL"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-full">
                        <div className="form-group">
                          <label>Company tagline:</label>
                          <Field
                            type="text"
                            name="tagline"
                            className="form-control"
                            rows="3"
                            placeholder="Enter tagline of company."
                          />
                          <ErrorMessage name="tagline" component="div" className="text-danger" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Company Logo:</label>
                          <input
                            type="file"
                            name="logo"
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={(event) => {
                              const file = event.currentTarget.files[0];
                              if (file) {
                                const validTypes = ["image/png", "image/jpeg", "image/jpg"];
                                if (validTypes.includes(file.type)) {
                                  setFieldValue("logo", file);
                                } else {
                                  alert("Only JPG, JPEG, and PNG files are allowed.");
                                  event.target.value = ""; // Clear invalid file
                                }
                              }
                            }}
                            className="form-control"
                          />
                          <ErrorMessage name="logo" component="div" className="text-danger" />
                        </div>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Creating...' : 'Create Company Profile'}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <SuccessModal
  show={showModal}
  onClose={() => {
    setShowModal(false);
    if (modalConfig.success) {
      refreshCompanyData();
      window.scrollTo(0, 0);
    }
  }}
  success={modalConfig.success}
  message={modalConfig.message}
/>
    </div>
  );
};

export default CreateCompany;